<template>
    <div class="Profile">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>프로필 수정</h2>
            <div class="btn_back">
                <a @click="slidePanelClose"><img src="@/assets/images/btn_back.png" width="50" alt="이전" /></a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <p class="profile-text mrg-top-30">커뮤니티에서 사용할 프로필과 별명을 설정하세요.</p>
            <div class="my-pic mrg-top-30">
                <img :src="profileImg" width="75" height="75" alt="사진">
            </div>
            <div class="text-center mrg-top-15">
                <div class="choose_file btn-pic">
                    <span>사진변경</span>
                    <input type="file"
                           @change="profileImgPreview($event)" />
                </div>
            </div>

            <div class="form-box mrg-top-30">
                <div class="input-box">
                    <div class="input-title"><span>별명</span></div>
                    <div class="input-item pdd-right-50">
                        <input type="text"
                               placeholder="별명을 입력해 주세요"
                               :disabled="bChangeableStatus==false"
                               v-model="strNickName">
                        <button class="ir btn-input-del"
                                @click="strNickName=''"
                                v-if="bChangeableStatus==true">
                            초기화
                        </button>
                    </div>
                </div>
            </div>

            <div class="profile-msg mrg-top-20">
                <p>한글, 영어, 숫자로만 입력해 주세요.</p>
                <p v-if="strChangeLabel!=''">{{ strChangeLabel }}</p>
            </div>

            <footer class="flex justify-between">
                <button class="btn-big btn-white mrg-right-10"
                        @click="slidePanelClose">
                    취소
                </button>
                <button class="btn-big btn-bule"
                        @click="formSend"
                >
                    저장
                </button>
            </footer>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>


export default {
    name: 'Profile',
    data() {
        return {
            errorField:'',          // error 항목
            errorMsg:'',            // error 메시지
            profileImg:'',          // 프로필이미지
            strNickName:'',         // 닉네임
            userProFile:'',         // 프로필 파일
            strChangeLabel:'',      // 안내문구구
            bChangeableStatus:'',   // 수정가능 여부
        }
    },
   // 감시자
    watch: {
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
        // 프로필 정보
        this.getProfileMeFunc();
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 프로필 정보
        getProfileMeFunc(){
            let param = {};
            this.ajaxGetAuth('/api/v1/profile/me', param, this.getProfileMeFuncResult);
        },
        // 프로필 정보 결과
        getProfileMeFuncResult(response){
            if (response.result.code == 0){
                this.profileImg = response.oProfile.oUser.profileImg;
                this.strNickName = response.oProfile.oUser.strNickName;
                this.strChangeLabel = response.oProfile.oUser.strChangeLabel;
                this.bChangeableStatus = response.oProfile.oUser.bChangeableStatus;

                this.$store.commit('setUserProfile',response.oProfile.oUser.profileImg);
                this.$store.commit('setUserName',response.oProfile.oUser.strNickName);

            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }
        },
        // 프로필 업로드 이미지 미리보기
        profileImgPreview(e){
            const file = e.target.files[0];
            this.profileImg = URL.createObjectURL(file);
            this.userProFile = file;
        },
        // 저장
        formSend(){
            let formData = new FormData();
            formData.append('strNickName', this.strNickName);
            formData.append('profileImage', this.userProFile);
            this.ajaxUpload('/api/v1/profile/me/modify', formData,this.formSendResult);
        },
        // 저장결과
        formSendResult(response){
            if (response.result.code == 0){
                this.getProfileMeFunc();
                //this.slidePanelClose('close');
                this.mypageSlideView();
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }
        },
    }
}
</script>

<style scoped>
    .profile-text { color: #737373; font-weight: 400; font-size: 13px; text-align: center}
    .my-pic {width: 75px;height: 75px;overflow: hidden;border-radius: 20px;margin: 0 auto;}
    .btn-pic {display: inline-block;border: 0;background-color: #00b7ee;border-radius: 20px;background-image: url("../../assets/images/icon-pic.png");background-repeat: no-repeat;background-position: center left 20px;background-size: 16px 14px;padding: 8px 20px 8px 40px;color: #fff;font-size: 16px;font-weight: 300;}
    .form-box {border: 2px solid #eeeeee;border-radius: 10px;}
    .input-title {justify-content: center;color: #bdbdbd;}
    .form-box input[type=text], input[type=password], input[type=number] {border: none;background: none;color: #000;text-indent: 0;}
    .profile-msg {color: #000; font-size: 14px;font-weight: 600}
    .profile-msg p{text-align: center;padding-top: 5px;}
    .profile-msg p:first-child{font-weight: 300}
    .profile-msg p:last-child{color: #017ff0}

    footer {position: fixed !important; bottom: 0px;left: 0;right: 0;padding: 20px 10px; background: #fff}


</style>
